import { MutableRefObject } from 'react';
import { styled } from 'styled-components';
import Input from 'components/ui/Input';

type PriceCellProps = {
    value: number | string | undefined;
    onChange: (value: string) => void;
    disabled?: boolean;
    isManualPrice?: boolean;
    isPercent?: boolean;
    placeholder?: string;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
};

const PriceCell = ({
    value,
    onChange,
    disabled = false,
    isManualPrice = false,
    isPercent = false,
    placeholder,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
}: PriceCellProps) => {
    // For percent type: editable only when isManualPrice=true
    // For price type: editable only when isManualPrice=true (existing behavior)
    const isEditable = isPercent ? isManualPrice : isManualPrice;

    return (
        <PriceCellWrapper>
            <StyledInput
                type="number"
                min={0}
                max={isPercent ? 100 : undefined}
                value={value ?? ''}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled || !isEditable}
                placeholder={placeholder}
                rounded
                ref={(el) => {
                    if (cellInputRefs && el) {
                        cellInputRefs.current[`additionalCosts-${rowIndex}-${colIndex}`] = el;
                    }
                }}
                onKeyDown={(e) => handleArrowKeyDown?.(e, 'additionalCosts', rowIndex, colIndex)}
            />
            {isPercent && <SuffixLabel>%</SuffixLabel>}
        </PriceCellWrapper>
    );
};

export default PriceCell;

const PriceCellWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
`;

const SuffixLabel = styled.span`
    flex-shrink: 0;
    opacity: 0.7;
`;

const StyledInput = styled(Input)`
    width: 100%;
    flex: 1;
    input {
        height: 32px !important;
        width: 100% !important;
        padding-left: 8px !important;
    }
`;
